import { render, staticRenderFns } from "./update-email.component.vue?vue&type=template&id=acadc04c&"
import script from "./update-email.component.vue?vue&type=script&lang=ts&"
export * from "./update-email.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports